import { api } from '@/scripts/api';

export const MDFPOPRequestService = {
    post(accountId, fundRequestId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/pop-accept`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },
}
